import { Route } from '@angular/router';
import { MainComponent } from './features/layouts/main/main.component';
import checkRedirectGuard from './utils/check-redirect.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    component: MainComponent,
    canActivate: [checkRedirectGuard],
    loadChildren: () => import('./features/layouts/main/main.module').then((m) => m.MainModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
